/** Allowed `users/{uid}.seenHints` values (onboarding script). */
// @ts-check

/** @typedef {'onboarding' | 'focusHint' | 'subtaskTeaser' | 'swipeTeaser' | 'organizeIntro' | 'backlogIntro' | 'inboxIntro' | 'contextIntro' | 'activationNotice' | 'streakTwo' | 'nextActionPanel' | 'triageHint' | 'quickAddHint'} OnboardingHint */

export const ONBOARDING_HINT_ONBOARDING = 'onboarding';
export const ONBOARDING_HINT_FOCUS = 'focusHint';
export const ONBOARDING_HINT_SUBTASK_TEASER = 'subtaskTeaser';
export const ONBOARDING_HINT_SWIPE_TEASER = 'swipeTeaser';
export const ONBOARDING_HINT_ORGANIZE_INTRO = 'organizeIntro';
export const ONBOARDING_HINT_BACKLOG_INTRO = 'backlogIntro';
export const ONBOARDING_HINT_INBOX_INTRO = 'inboxIntro';
export const ONBOARDING_HINT_CONTEXT_INTRO = 'contextIntro';
export const ONBOARDING_HINT_ACTIVATION_NOTICE = 'activationNotice';
export const ONBOARDING_HINT_STREAK_TWO = 'streakTwo';
export const ONBOARDING_HINT_NEXT_ACTION_PANEL = 'nextActionPanel';
export const ONBOARDING_HINT_TRIAGE = 'triageHint';
export const ONBOARDING_HINT_QUICK_ADD = 'quickAddHint';

/** @type {readonly OnboardingHint[]} */
export const ONBOARDING_HINTS = [
  ONBOARDING_HINT_ONBOARDING,
  ONBOARDING_HINT_FOCUS,
  ONBOARDING_HINT_SUBTASK_TEASER,
  ONBOARDING_HINT_SWIPE_TEASER,
  ONBOARDING_HINT_ORGANIZE_INTRO,
  ONBOARDING_HINT_BACKLOG_INTRO,
  ONBOARDING_HINT_INBOX_INTRO,
  ONBOARDING_HINT_CONTEXT_INTRO,
  ONBOARDING_HINT_ACTIVATION_NOTICE,
  ONBOARDING_HINT_STREAK_TWO,
  ONBOARDING_HINT_NEXT_ACTION_PANEL,
  ONBOARDING_HINT_TRIAGE,
  ONBOARDING_HINT_QUICK_ADD,
];

/** @type {ReadonlySet<string>} */
export const VALID_ONBOARDING_HINTS = new Set(ONBOARDING_HINTS);
